import type { FleetSnapshot, FleetSnapshotTotals } from "@/api/fleet";

interface Props {
  snapshot: FleetSnapshot | undefined;
}

const EMPTY: FleetSnapshotTotals = {
  totalUnits: 0,
  monitoreando: 0,
  detenido: 0,
  enPausa: 0,
  offline: 0,
  hitsToday: 0,
  distanciaKmToday: 0,
  anomaliasAbiertas: 0,
};

interface TileSpec {
  label: string;
  value: string | number;
  tone: "neutral" | "positive" | "warning" | "danger";
}

export function FleetTotalsBar({ snapshot }: Props) {
  const totals: FleetSnapshotTotals = snapshot?.totals ?? EMPTY;
  const tiles: TileSpec[] = [
    {
      label: "Unidades",
      value: totals.totalUnits,
      tone: "neutral",
    },
    {
      label: "Monitoreando",
      value: totals.monitoreando,
      tone: "positive",
    },
    {
      label: "Detenidas",
      value: totals.detenido,
      tone: "warning",
    },
    {
      label: "En pausa",
      value: totals.enPausa,
      tone: "warning",
    },
    {
      label: "Offline",
      value: totals.offline,
      tone: "danger",
    },
    {
      label: "Hits hoy",
      value: totals.hitsToday,
      tone: totals.hitsToday > 0 ? "danger" : "neutral",
    },
    {
      label: "Distancia hoy",
      value: `${totals.distanciaKmToday.toFixed(1)} km`,
      tone: "neutral",
    },
    {
      label: "Anomalías abiertas",
      value: totals.anomaliasAbiertas,
      tone: totals.anomaliasAbiertas > 0 ? "warning" : "neutral",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 px-3 py-2 border-b border-border bg-surface md:grid-cols-4 lg:grid-cols-8">
      {tiles.map((t) => (
        <Tile key={t.label} {...t} />
      ))}
    </div>
  );
}

function Tile({ label, value, tone }: TileSpec) {
  const toneClass =
    tone === "positive"
      ? "text-emerald-400"
      : tone === "warning"
        ? "text-amber-400"
        : tone === "danger"
          ? "text-rose-400"
          : "text-foreground";
  return (
    <div className="rounded-md bg-surface2/40 px-3 py-2">
      <div className="text-[10px] uppercase tracking-wide text-muted-200">
        {label}
      </div>
      <div className={`text-lg font-semibold ${toneClass}`}>{value}</div>
    </div>
  );
}
